import { IContextMenuItem } from '@smartshell/ui-kit';

import { openConfirmDialog } from '../../../services/Confirmation';
import s from '../ContextMenuItems.module.scss';
import { CtxMenuHost } from '../interfaces';
import { TGetPowerItemsArgs } from './interfaces';
export const getPowerItems: TGetPowerItemsArgs = ({
  t,
  selectedHostsIds,
  sendCommand,
  permissions,
  disabledPowerOn,
  hosts,
  sendCommands,
}) => {
  const selectedHosts = hosts?.filter((host) =>
    selectedHostsIds?.includes(host.id)
  );
  const electricityItems: Array<IContextMenuItem<CtxMenuHost>> = [
    {
      key: 'on',
      text: t('host.ctx.on'),
      iconName: 'ShutdownIcon',
      disabled: (host) => {
        if (selectedHostsIds?.length === 1 && host.online) {
          return true;
        }

        if (selectedHostsIds && selectedHostsIds?.length > 1) {
          if (selectedHosts?.some((host) => host.online)) {
            return true;
          }
        }

        return false;
      },
      onClick: (host) => {
        const { id } = host;
        if (!host.online) {
          if (!selectedHostsIds?.length) {
            return sendCommand({ host_id: id, action: 'WOL' });
          } else if (selectedHostsIds.length === 1) {
            return sendCommand({ host_id: selectedHostsIds[0], action: 'WOL' });
          } else {
            return sendCommands({ host_ids: selectedHostsIds, action: 'WOL' });
          }
        }
      },
    },
    {
      key: 'off',
      text: t('host.ctx.off'),
      iconName: 'ShutdownIcon',
      disabled: (host) => {
        if (!host.mac_addr || disabledPowerOn) {
          return true;
        }

        if (selectedHostsIds?.length === 1 && !host.online) {
          return true;
        }

        if (selectedHostsIds && selectedHostsIds?.length > 1) {
          if (selectedHosts?.every((host) => !host.online)) {
            return true;
          }
        }

        return false;
      },
      className: s['red-text'],
      onClick: (host) => {
        const host_id = selectedHostsIds?.[0] || host.id;

        if (selectedHostsIds && selectedHostsIds.length > 1) {
          return sendCommands({
            host_ids: selectedHostsIds,
            action: 'SHUTDOWN',
          });
        } else if (host.client_sessions.length) {
          return openConfirmDialog(t, 'remove', {
            title: t('notifyService.shutdown.title'),
            message: t('notifyService.shutdown.description', host.alias),
            acceptTitle: t('notifyService.shutdown.accept'),
          }).then(({ status }) => {
            if (status === 'ACCEPTED') {
              return sendCommand({ host_id: host_id, action: 'SHUTDOWN' });
            }
          });
        } else {
          return sendCommand({ host_id: host_id, action: 'SHUTDOWN' });
        }
      },
    },
    {
      key: 'logout',
      text: t('host.ctx.logout'),
      iconName: 'HostLogoutIcon',
      disabled: (host) => {
        if (selectedHosts?.length === 1) return !host.online || host.locked;

        if (selectedHostsIds && selectedHostsIds?.length > 1) {
          if (selectedHosts?.every((host) => !host.online || host.locked)) {
            return true;
          }
        }
        return false;
      },
      onClick: ({ id, client_sessions, alias }) => {
        const host_id = selectedHostsIds?.[0] || id;

        if (selectedHostsIds && selectedHostsIds.length > 1) {
          return sendCommands({ host_ids: selectedHostsIds, action: 'LOGOFF' });
        } else if (client_sessions.length) {
          return openConfirmDialog(t, 'remove', {
            title: t('notifyService.logout.title'),
            message: t('notifyService.logout.description', alias),
            acceptTitle: t('notifyService.logout.accept'),
          }).then(({ status }) => {
            if (status === 'ACCEPTED') {
              return sendCommand({ host_id: host_id, action: 'LOGOFF' });
            }
          });
        } else {
          return sendCommand({ host_id: host_id, action: 'LOGOFF' });
        }
      },
      isLastInGroup: true,
    },
    {
      key: 'reboot',
      text: t('host.ctx.reboot'),
      iconName: 'RestartIcon',
      disabled: (host) => {
        if (selectedHostsIds?.length === 1 && host.online) return false;
        if (selectedHostsIds && selectedHostsIds?.length > 1) {
          if (selectedHosts?.every((host) => host.online)) return false;
        }
        return true;
      },
      onClick: ({ id, client_sessions, alias }) => {
        const host_id = selectedHostsIds?.[0] || id;

        if (selectedHostsIds && selectedHostsIds.length > 1) {
          return sendCommands({ host_ids: selectedHostsIds, action: 'REBOOT' });
        } else if (client_sessions.length) {
          return openConfirmDialog(t, 'remove', {
            title: t('notifyService.reboot.title'),
            message: t('notifyService.reboot.description', alias),
            acceptTitle: t('notifyService.reboot.accept'),
          }).then(({ status }) => {
            if (status === 'ACCEPTED') {
              return sendCommand({ host_id: host_id, action: 'REBOOT' });
            }
          });
        } else {
          return sendCommand({ host_id: host_id, action: 'REBOOT' });
        }
      },
    },
  ];

  return !permissions?.has('host_command_manage')
    ? null
    : {
        key: 'power',
        text: t('host.ctx.power'),
        iconName: 'ThunderIcon',
        disabled: ({ locked }) => locked,
        subMenu: electricityItems,
      };
};
